import { useParams } from 'react-router-dom'
import Page from 'layout/page'
import PageTitle from 'layout/page-title'
import SampleDetail from 'dashboard/samples/sample-detail'
import { useFolderContext, folderReturnCrumbUrl } from 'dashboard/folders/folder-context'

const SampleShow = () => {
  const { id } = useParams()
  // Opened from a folder on the index, the crumb goes back to that folder rather than to the top
  // of the index.
  const folderId = useFolderContext()

  return (
    <Page title="Sample">
      <PageTitle
        breadcrumbs={[
          { name: 'Views', url: folderReturnCrumbUrl(folderId) },
          { name: 'Sample', url: '' }
        ]}
      />
      <SampleDetail
        sampleId={id}
        dashboardId={null}
        cardHeader
      />
    </Page>
  )
}

export default SampleShow
